import PropTypes from "prop-types";
import { get, isEmpty } from "lodash";
import classNames from "classnames";
import "./LogoLoader.css";
import { ICONS } from "./constants";
const LogoLoader = (props) => {
  const {
    id = "",
    description = "",
    height = null,
    width = null,
    styleClass = "",
    color = "brand-blue"
  } = props;
  const icon = ICONS.IconLogoLoader;
  const iconImage = get(icon, "markup", null);
  const viewBox = get(icon, "viewBox", null);

  const logoClass = classNames(`logo-loader text-${color}`, styleClass);
  return (
    <div className={logoClass} id={id}>
      <svg height={height} width={width} viewBox={viewBox}>
        {iconImage}
      </svg>
      {!isEmpty(description) && (
        <p className="logo-loader__text text-center">{description}</p>
      )}
    </div>
  );
};

LogoLoader.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** text to appear below UULogoLoader image */
  description: PropTypes.string,
  /** height of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  height: PropTypes.number,
  /** width of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
   */
  width: PropTypes.number,
  /** Use custom tailwind classes - Replaces style object */
  styleClass: PropTypes.string,
};

export default LogoLoader;
